import React from "react";
import { Alert, Col, Row, Statistic, Table, Tag, Typography } from "antd";

const { Text } = Typography;

const statusColor = {
  ready: "blue",
  applied: "green",
  unchanged: "default",
  skipped: "orange",
  failed: "red"
};

const statusLabel = {
  ready: "Ready to apply",
  applied: "Applied",
  unchanged: "Already up to date",
  skipped: "Not eligible",
  failed: "Needs attention"
};

const actionLabel = {
  created: "Add quota",
  updated: "Update quota",
  assigned: "Link policy",
  unchanged: "Already up to date",
  skipped: "Not eligible",
  failed: "Needs attention"
};

const LeaveTypeAssignmentPreview = ({ previewData }) => {
  const results = previewData?.results || [];
  const summary = previewData?.summary || {};
  const hasBlockingRows = (summary.failed || 0) > 0;
  const hasSkippedRows = (summary.skipped || 0) > 0;

  return (
    <>
      <Alert
        className="da-mb-16"
        message="Review changes before applying leave policies"
        description="Check which employees will receive a new or updated quota, and review anyone who is not eligible."
        type={ hasBlockingRows ? "error" : hasSkippedRows ? "warning" : "info" }
        showIcon
      />
      <Row gutter={ 16 } className="da-mb-16">
        <Col xs={ 12 } md={ 4 }><Statistic title="Employees & policies" value={ summary.total || 0 } /></Col>
        <Col xs={ 12 } md={ 4 }><Statistic title="New quotas" value={ summary.created || 0 } /></Col>
        <Col xs={ 12 } md={ 4 }><Statistic title="Quota updates" value={ summary.updated || 0 } /></Col>
        <Col xs={ 12 } md={ 4 }><Statistic title="Policies to link" value={ summary.assigned || 0 } /></Col>
        <Col xs={ 12 } md={ 4 }><Statistic title="Not eligible" value={ summary.skipped || 0 } /></Col>
        <Col xs={ 12 } md={ 4 }><Statistic title="Needs attention" value={ summary.failed || 0 } /></Col>
      </Row>
      <Table
        size="small"
        rowKey={ (_, index) => index }
        pagination={ { pageSize: 10 } }
        dataSource={ results }
        columns={ columns }
      />
    </>
  );
};

export default LeaveTypeAssignmentPreview;

const columns = [
  {
    title: "Employee",
    dataIndex: "employee_name",
    key: "employee_name",
    render: (value) => value || "-"
  },
  {
    title: "Leave Policy",
    dataIndex: "leave_type_name",
    key: "leave_type_name",
    render: (value) => value || "-"
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (value) => <Tag color={ statusColor[value] || "default" }>{ statusLabel[value] || "Unknown" }</Tag>
  },
  {
    title: "What will happen",
    dataIndex: "action",
    key: "action",
    render: (value) => actionLabel[value] || value || "-"
  },
  {
    title: "Allowed days",
    key: "quota",
    render: (_, record) => (
      <Text>
        { record.quota_before ?? "-" } -> { record.quota_after ?? "-" }
      </Text>
    )
  },
  {
    title: "Quota period",
    key: "quota_period",
    render: (_, record) => (
      <Text>
        { record.fiscal_year_start && record.fiscal_year_end
          ? `${record.fiscal_year_start} -> ${record.fiscal_year_end}`
          : "-" }
      </Text>
    )
  },
  {
    title: "Available balance",
    key: "available",
    render: (_, record) => (
      <Text>
        { record.available_before ?? "-" } -> { record.available_after ?? "-" }
      </Text>
    )
  },
  {
    title: "Reason",
    dataIndex: "reason",
    key: "reason",
    render: (value) => value || "-"
  }
];
